<template>
  <v-dialog scrollable max-width="600px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-btn icon>
        <v-icon color="grey lighten-1" v-on="on" @click="init">mdi-information</v-icon>
      </v-btn>
    </template>
    <v-card v-if="loading" max-width="800" max-height="80%">
      <v-card-title>
        <h4 v-if="loading">cargando . . .</h4>
      </v-card-title>
    </v-card>
    <v-card max-width="800" height="80%" v-if="!loading">
      <v-card-title>
        <h4>{{ exp.numeroExpediente }} - {{ exp.fechaExpediente | dateFormat }} {{ exp.horaExpediente | timeFormat }}
        </h4>
      </v-card-title>
      <v-card-text>
        <v-container id="scroll-target" class="overflow-y-auto" style="max-height: 600px">
          <h2 class="mb-2">{{ exp.recurrente }}</h2>
          <h3>{{ exp.referencia }}</h3>

          <div v-if="exp.observaciones">
            <h5 class="mt-2">OBS: {{ exp.observaciones }}</h5>
          </div>

          <v-list subheader two-line>

            <v-list-item v-for="d in detalle" :key="d.fecha">

              <v-list-item-content>
                <v-list-item-subtitle> {{ d.fecha | dateTimeFormat }} - {{ d.departamento }}</v-list-item-subtitle>
                <v-list-item-subtitle> {{ d.estado }} -  {{ d.usuario.toUpperCase() }} </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

          </v-list>

        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import axios from "axios";
import moment from "moment";

export default {
  props: ["exp"],

  data: () => ({
    showDialog: false,
    loading: true,
    detalle: []
  }),
  methods: {
    async init() {
      await axios.get('/expedientes/' + this.exp.idRecepcion).then(res => {
        this.detalle = res.data;
      }).catch(err => {
        console.log(err);
      });
      this.loading = false
    },
    volver() {
      this.showDialog = false;
    }
  },
  filters: {
    dateFormat(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    dateTimeFormat(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm");
      }
    },
    timeFormat(value) {
      if (value) {
        const h = '2004/01/01 ' + value;
        return moment(String(h)).format("HH:MM");
      }
    },
    dateYear(value) {
      if (value) {
        return moment(String(value)).format("YYYY");
      }
    },
  },
}

</script>